import React from "react";
import CTAPage from "./CTAPage";

const Careers = () => (
  <CTAPage
    eyebrow="Careers"
    title="Build a career in care that truly matters"
    subtitle="Join a warm, growing team that treats home care like family. We're hiring trained nurses, caregivers, physiotherapists and care managers across our cities — with fair pay, ongoing training and genuine respect."
    image="/generated/careers_hero.png"
    highlights={[
      "Competitive pay & timely payouts",
      "Regular training & upskilling",
      "Supportive, respectful workplace",
      "Flexible day, night & live-in roles",
    ]}
    formProps={{
      heading: "Apply to join us",
      subheading: "Share your details and the role you're interested in — our team will reach out.",
      category: "Career",
      extraLabel: "Applying for role",
      extraOptions: [
        "Home Nurse",
        "Caregiver / Attendant",
        "Physiotherapist",
        "Doctor",
        "Care Manager",
        "Lab Technician",
        "Other",
      ],
      submitLabel: "Submit Application",
    }}
  />
);

export default Careers;
